import { ExplanationModel } from "src/data/models/ExplanationModel";
import { VerbConjugation } from "src/data/models/VerbConjugationModel";
import { Example } from "../models/ExampleModel";

export const CondicionalSimpleData = {
  explanation: {
    title: "📖 What is Condicional Simple?",
    description:
      "The conditional tense is used to express hypothetical situations, polite requests, and future actions viewed from a past perspective.",
    bulletPoints: [
      "Hypothetical situations: 'Si tuviera dinero, viajaría por el mundo.  → If I had money, I would travel the world.'",
      "Politeness: '¿Podrías ayudarme?  → Could you help me?'",
      "Expressing probability in the past: 'Serían las 10 de la noche. → It would be 10 at night.'",
    ],
    examples: [],
    
  } as ExplanationModel,

  examples: [
    {
      sentence: "Si fuera rico, compraría una casa en la playa.",
      explanation:
        "🏖️ Hypothetical Condition – 'If I were rich, I would buy a house by the beach.' This example illustrates a hypothetical situation that is unlikely or not real.",
    },
    {
      sentence: "Me encantaría visitar Japón algún día.",
      explanation:
        "✈️ Desire – 'I would love to visit Japan someday.' This expresses a desire or wish for something that may or may not happen.",
    },
    {
      sentence: "¿Podrías decirme la hora?",
      explanation:
        "⏰ Polite Request – 'Could you tell me the time?' This is a polite way to ask for something using the conditional tense.",
    },
  ] as Example[],

  regularVerbs: [
    {
      verb: "Hablar",
      conjugations: ["hablaría", "hablarías", "hablaría", "hablaríamos", "hablaríais", "hablarían"],
    },
    {
      verb: "Comer",
      conjugations: ["comería", "comerías", "comería", "comeríamos", "comeríais", "comerían"],
    },
    {
      verb: "Vivir",
      conjugations: ["viviría", "vivirías", "viviría", "viviríamos", "viviríais", "vivirían"],
    },
    {
      verb: "Trabajar",
      conjugations: ["trabajaría", "trabajarías", "trabajaría", "trabajaríamos", "trabajaríais", "trabajarían"],
    },
    {
      verb: "Estudiar",
      conjugations: ["estudiaría", "estudiarías", "estudiaría", "estudiaríamos", "estudiaríais", "estudiarían"],
    },
  ] as VerbConjugation[],

  irregularVerbs: [
    {
      verb: "Tener",
      conjugations: ["tendría", "tendrías", "tendría", "tendríamos", "tendríais", "tendrían"],
    },
    {
      verb: "Hacer",
      conjugations: ["haría", "harías", "haría", "haríamos", "haríais", "harían"],
    },
    {
      verb: "Decir",
      conjugations: ["diría", "dirías", "diría", "diríamos", "diríais", "dirían"],
    },
    {
      verb: "Poder",
      conjugations: ["podría", "podrías", "podría", "podríamos", "podríais", "podrían"],
    },
  ] as VerbConjugation[],

  timelineDescription: {
    title: "Visualizing the Conditional Tense",
    description:
      "The conditional tense is often used to describe an action that could happen if a certain condition is met. Think of it as a \"What if?\" scenario. The timeline below shows how it relates to present and past events.",
    examples: [
      "Si estudiaras más, aprobarías el examen. (If you studied more, you would pass the exam.)",
    ],
  } as ExplanationModel,
};
